import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, HStack, VStack, Copy, NewPrimaryButton } from '../../SimpleUI';
import HeroMain from '../../../assets/images/hero_main.png';
import HeroMainMx from '../../../assets/images/hero_main_mx.png';
import SectionLayout from '../SectionLayout';
import useDesignUtils from '../../../hooks/useDesignUtils';
import { useCountry } from '../../../contexts/CountryContext';

const Hero = () => {
  const { isMobile } = useDesignUtils();
  const history = useHistory();
  const { countryPrefix } = useCountry();

  const StackDirection = isMobile ? VStack : HStack;

  const texts = {
    '/ar': {
      header: 'Tus metas merecen ser alcanzadas',
      subtitle: `Ahorrá en más de 100 propiedades y recibí ganancias en dólares a partir del primer mes, ganando desde un 8% de rentabilidad anual con la seguridad del ladrillo.
      Estas a un clic de distancia!`,
    },
    '/mx': {
      header:
        'Maximiza tu potencial financiero con tan sólo 100 MXN y en 1 clic.',
      subtitle:
        'Ahorra en propiedades en Estados Unidos y recibe ganancias a partir del primer mes, con un 10% de rentabilidad anual.',
    },
  };

  return (
    <SectionLayout
      paddingY="medium"
      backgroundColor="white"
      height="calc(100vh - 60px)"
    >
      <Box width="100%" paddingX="medium" maxWidth="1200px" margin="auto">
        <StackDirection
          justifyContent="space-between"
          alignItems="center"
          space="large"
        >
          <VStack width={{ mobile: '100%', desktop: '50%' }} space="xlarge">
            <Copy
              fontSize="bigHeader"
              fontWeight="bold"
              tag="h1"
              style={{ textWrap: 'balance' }}
            >
              {texts[countryPrefix].header}
            </Copy>
            <Copy fontSize="subtitle">{texts[countryPrefix].subtitle}</Copy>
            <Box
              width="100%"
              maxWidth={{ mobile: '350px', desktop: '200px' }}
              margin={{ mobile: 'auto', desktop: 'none' }}
            >
              <NewPrimaryButton
                type="button"
                size="full"
                onClick={() => history.push(`${countryPrefix}/productos`)}
              >
                Invertir
              </NewPrimaryButton>
            </Box>
          </VStack>
          <Box
            maxWidth={{
              mobile: '300px',
              desktop: '500px',
            }}
            margin={{ mobile: 'auto', desktop: 'none' }}
            width="100%"
            paddingTop="large"
          >
            <Box
              tag="img"
              src={countryPrefix === '/ar' ? HeroMain : HeroMainMx}
              width="100%"
              maxWidth="600px"
            />
          </Box>
        </StackDirection>
      </Box>
    </SectionLayout>
  );
};

export { Hero };
